import type { ContactEntityKind } from "@domaddress/shared";

/** Hono API-bases voor de gedeelde contacttabel. */
export const VRIJWILLIGERS_API = "/api/vrijwilligers";
export const PERSONEEL_API = "/api/personeel";
/** Kaarten met entity_kind dominicusganger (API-pad zoals op de server). */
export const DOMINICUSGANGERS_API = "/api/dominicusgangers";
export const EXTERNE_CONTACTEN_API = "/api/externe-contacten";
export const LEVERANCIERS_API = "/api/leveranciers";
/** Backward-compat: alleen vrijwilligers-API. Voor vrijwilliger én personeel: beide paden apart ophalen en mergen. */
export const MEDEWERKERS_API = VRIJWILLIGERS_API;
/** Niet filteren op entity_kind. */
export const ALLE_CONTACTEN_API = "/api/contacts";

/** App-route voor de contactlijst (diep-link vanuit o.a. activiteitenlog). */
export function contactListAppPath(entityKind: ContactEntityKind | string | undefined | null): string {
  switch (entityKind) {
    case "personeel":
      return "/personeel";
    case "vrijwilliger":
      return "/vrijwilligers";
    case "dominicusganger":
      return "/dominicusgangers";
    case "extern":
      return "/externe-contacten";
    case "leverancier":
      return "/leveranciers";
    case "emaillijst":
      return "/alle-contacten";
    default:
      return "/vrijwilligers";
  }
}

/** Welk REST-pad hoort bij deze kaart (voor o.a. ContactViewModal na klik vanuit een groep). */
export function contactListApiPath(entityKind: ContactEntityKind | string | undefined | null): string {
  switch (entityKind) {
    case "personeel":
      return PERSONEEL_API;
    case "vrijwilliger":
      return VRIJWILLIGERS_API;
    case "dominicusganger":
      return DOMINICUSGANGERS_API;
    case "extern":
      return EXTERNE_CONTACTEN_API;
    case "leverancier":
      return LEVERANCIERS_API;
    case "emaillijst":
      return ALLE_CONTACTEN_API;
    default:
      return VRIJWILLIGERS_API;
  }
}

/** Korte titel in het bekijk-venster (zelfde logica als lijstpagina’s). */
export function contactModalTitle(entityKind: ContactEntityKind | string | undefined | null): string {
  switch (entityKind) {
    case "personeel":
      return "Personeelslid";
    case "vrijwilliger":
      return "Vrijwilliger";
    case "dominicusganger":
      return "Dominicusganger";
    case "extern":
      return "Extern contact";
    case "leverancier":
      return "Leverancier";
    case "emaillijst":
      return "E-mailabonnee";
    default:
      return "Contact";
  }
}
